import React from 'react'
import { LoadState } from '@ally/use-data-domain'
import { Box, TextBody, SkeletonLoader as Skeleton } from '@ally/metronome-ui'

import { BadgeIcon } from './StyledComponents'

type BadgeProps = {
  badgeType?: 'default' | 'progress'
  icon: React.ReactNode
  heading: React.ReactNode
  desc: React.ReactNode
  progressBar?: React.ReactNode
  progressText?: React.ReactNode
  status: LoadState
}

type SkeletonProps = { badgeType: string }
const SkeletonBadge: React.FC<SkeletonProps> = ({ badgeType }) => (
  <Skeleton.Container isLoading>
    <Skeleton.Row height={badgeType === 'default' ? 'l' : 'xl'} width="xl" />
  </Skeleton.Container>
)

const Badge: React.FC<BadgeProps> = ({
  badgeType = 'default',
  icon,
  heading,
  desc,
  progressBar,
  progressText,
  status,
}) => {
  switch (status) {
    case LoadState.LOADED:
      return badgeType === 'progress' ? (
        <Box display="flex" alignItems="flex-start">
          <BadgeIcon badgeType={badgeType}>{icon}</BadgeIcon>
          <Box display="flex" flexDirection="column">
            <Box>
              <TextBody tag="p" size="md" weight="bold">
                {heading}
              </TextBody>
              <TextBody tag="p" size="sm">
                {desc}
              </TextBody>
            </Box>
            <Box display="flex" flexDirection="column">
              <Box mt="sm">{progressBar}</Box>
              <Box>{progressText}</Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box display="flex" alignItems="center">
          <BadgeIcon badgeType={badgeType}>{icon}</BadgeIcon>
          <Box>
            <TextBody tag="p" size="md" weight="bold">
              {heading}
            </TextBody>
            <TextBody tag="p" size="sm">
              {desc}
            </TextBody>
          </Box>
        </Box>
      )

    case LoadState.LOADING:
      return <SkeletonBadge badgeType={badgeType} />
    case LoadState.FAILED:
      return null

    default:
      return null
  }
}

export { Badge }
